import { statusOf } from "@/lib/constants";

export default function StatusBadge({ status }) {
  const s = statusOf(status);
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
}
